import {
  LiveChatPreEngagementData,
  MessageRole,
  WiseOwlApiIngress,
  WiseOwlApiResponse,
  WiseOwlBlockDisplayType,
  WiseOwlBlockType,
  WiseOwlChatType,
  WiseOwlCreateChatResponseData,
  WiseOwlCreateFeedbackBodyInternal,
  WiseOwlCreateFeedbackBodyOsc,
  WiseOwlCreateUpdateBodyDefaults,
  WiseOwlCreateUpdateBodyOsc,
  WiseOwlCreateUpdateBodyOscUngated,
  WiseOwlCreateUpdateBodyZendesk,
  WiseOwlGetAccessTokenHeadersZendesk,
  WiseOwlGetChatByIdResponseData,
  WiseOwlGetChatSummaryByIdResponseData,
  WiseOwlGetHomeResponseData,
  WiseOwlHeadersSalesforce,
  WiseOwlHeadersZendesk,
  WiseOwlTransferToLiveChatBodyOsc,
  WiseOwlTransferToLiveChatResponseData,
  WiseOwlUpdateChatResponseData,
} from "../types";

export const mockCsrf = "csrf";
export const mockToken = "token";
export const mockRecaptchaToken = "also-a-token";
export const mockStargateUngatedUserId = "b441d9ac-65b8-4af3-aa1f-04d75104e0fe";
export const mockChatId = "32798537-32589235-325235";

export const mockTwilioSyncAccessToken =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTS3h4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4LTE0NTA0NzExNDciLCJpc3MiOiJTS3h4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4Iiwic3ViIjoiQUN4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eCIsIm5iZiI6MTQ1MDQ3MTE0NywiZXhwIjoxNDUwNDc0NzQ3LCJncmFudHMiOnsiaWRlbnRpdHkiOiJ1c2VyQGV4YW1wbGUuY29tIiwiaXBfbWVzc2FnaW5nIjp7InNlcnZpY2Vfc2lkIjoiSVN4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eCIsImVuZHBvaW50X2lkIjoiSGlwRmxvd1NsYWNrRG9ja1JDOnVzZXJAZXhhbXBsZS5jb206c29tZWlvc2RldmljZSJ9fX0.IHx8KeH1acIfwnd8EIin3QBGPbfnF-yVnSFp5NpQJi0";
export const mockTwilioSyncDocumentSid = "ETXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";

export const mockDefaultHeaders = {
  "Content-type": "application/json",
};

export const mockTwilioHeaders = {
  ...mockDefaultHeaders,
  "x-twilio-csrf": mockCsrf,
};

export const mockSalesforceHeaders: WiseOwlHeadersSalesforce = {
  ...mockDefaultHeaders,
  "salesforce-auth": mockToken,
};

export const mockZendeskAuthHeaders: WiseOwlGetAccessTokenHeadersZendesk = {
  "zendesk-user-id": "123",
};

export const mockZendeskHeaders: WiseOwlHeadersZendesk = {
  ...mockDefaultHeaders,
  "wozd-auth": mockToken,
};

export const mockRequestOptions = {
  credentials: "include",
};

export const mockZendeskCreateUpdateBody: WiseOwlCreateUpdateBodyZendesk = {
  input: "I think you are way cool, Wise Owl, but from Zendesk",
  stream: true,
  ticket: {
    id: 123456,
    subject: "I think you are way cool, Wise Owl, but from Zendesk",
    conversation: [],
  },
};

export const mockBaseCreateUpdateBody: WiseOwlCreateUpdateBodyDefaults = {
  input: "I think you are way cool, Wise Owl",
  stream: true,
};

export const mockOscCreateUpdateBody: WiseOwlCreateUpdateBodyOsc = {
  ...mockBaseCreateUpdateBody,
};

export const mockOscUngatedCreateUpdateBody: WiseOwlCreateUpdateBodyOscUngated =
  {
    ...mockOscCreateUpdateBody,
    stargateUngatedUserId: mockStargateUngatedUserId,
  };

export const mockBasePositiveFeedbackBody: WiseOwlCreateFeedbackBodyInternal = {
  feedback: "",
  positive: true,
};

export const mockPositiveFeedbackBody: WiseOwlCreateFeedbackBodyOsc = {
  ...mockBasePositiveFeedbackBody,
};

export const mockNegativeFeedbackBody: WiseOwlCreateFeedbackBodyOsc = {
  feedback: "I <3 Wise Owl",
  positive: true,
};

export const mockOscChat: WiseOwlChatType = {
  id: "739878998798",
  aboutTicketId: 372373298379823,
  createdAt: "2024-03-04T20:37:26.255Z",
  updatedAt: "2024-03-04T20:37:26.255Z",
  userId: "US046e8c33ddaa77748de95b406cc454cc",
  title: "Wow, way super nice. Best AI assistant ever.",
  ingress: WiseOwlApiIngress.OneSupportCenter,
  slackThreadTimestamp: null,
  slackConversationId: null,
  blocks: [],
  messages: [
    {
      id: "542",
      createdAt: "2024-03-04T20:37:35.847Z",
      updatedAt: "2024-03-04T20:37:35.847Z",
      chatId: "189",
      messageRole: MessageRole.User,
      content: "Wow, way super nice. Best AI assistant ever.",
      userId: null,
      slackMessageTimestamp: null,
      isComplete: null,
      toolCalls: [],
    },
    {
      id: "543",
      createdAt: "2024-03-04T20:37:35.847Z",
      updatedAt: "2024-03-04T20:37:35.847Z",
      chatId: "189",
      messageRole: MessageRole.Assistant,
      content:
        "Thank you so much for your kind words! I'm here to make sure you get the support and guidance you need. 😊 Is there anything specific you would like assistance with? Or are you encountering any issues we can help you with today?",
      userId: null,
      slackMessageTimestamp: null,
      isComplete: null,
      toolCalls: [
        {
          id: "48",
          createdAt: "2024-03-04T20:37:35.847Z",
          updatedAt: "2024-03-04T20:37:35.847Z",
          messageId: "543",
          name: "classifyCustomerIntent",
          input:
            '{\n    "transcript": "[user]\\n\\tWow, way super nice. Best AI assistant ever."\n}',
          output:
            '{"intent":"NONE","explanation":"The user\'s message is a compliment and does not contain any request for support or a specific query that could be classified into one of the given intents.","followUpQuestions":["Is there anything specific you would like assistance with?","Are you encountering any issues we can help you with today?"]}',
          formattedOutput:
            '{"intent":"NONE","explanation":"The user\'s message is a compliment and does not contain any request for support or a specific query that could be classified into one of the given intents.","followUpQuestions":["Is there anything specific you would like assistance with?","Are you encountering any issues we can help you with today?"]}',
        },
      ],
    },
  ],
};

export const mockOneAdminChat: WiseOwlChatType = {
  createdAt: "2023-11-02T22:02:53.627Z",
  id: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
  ingress: WiseOwlApiIngress.OneAdmin,
  aboutTicketId: 1234567890,
  blocks: [],
  messages: [
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello wise owl",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c52",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello! How can I assist you with Twilio today?",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c53",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "AI",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "What is error code 30034?",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c54",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content:
        "This error occurs when messages sent to US numbers are not delivered.",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c56",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "AI",
      toolCalls: [],
    },
  ],
  slackConversationId: null,
  slackThreadTimestamp: null,
  title: "Hello wise owl",
  updatedAt: "2023-11-02T22:02:53.627Z",
  userId: "nobody",
};

export const mockChatHistoryData = [
  {
    createdAt: "2023-12-13T16:10:16.578Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Hi Wise Owl. Could you tell me highlights from Twilio's",
    updatedAt: "2023-12-13T16:10:16.578Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
    aboutTicketId: 1234567890,
    blocks: [],
  },
  {
    createdAt: "2023-12-13T16:11:46.679Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e76",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Could you tell me more about what COMM-1934 is all",
    updatedAt: "2023-12-13T16:11:46.679Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
    aboutTicketId: 1234567890,
    blocks: [],
  },
  {
    createdAt: "2023-12-13T20:53:56.819Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e77",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Based on what, do fraudsters attack a country? Why/how",
    updatedAt: "2023-12-13T20:53:56.819Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
    aboutTicketId: 1234567890,
    blocks: [],
  },
];

export const mockWiseOwlGetChatByIdResponse: WiseOwlApiResponse<WiseOwlGetChatByIdResponseData> =
  {
    success: true,
    message: "success",
    statusCode: 200,
    data: { chat: mockOscChat, blocks: [] },
  };

export const mockWiseOwlGetChatByUserResponse = {
  statusCode: 200,
  data: {
    chats: [mockOscChat],
  },
};

export const mockWiseOwlCreateChatStreamResponse: WiseOwlApiResponse<WiseOwlCreateChatResponseData> =
  {
    success: true,
    message: "success",
    statusCode: 200,
    data: {
      accessToken: mockTwilioSyncAccessToken,
      syncDocumentSid: mockTwilioSyncDocumentSid,
      chatId: mockChatId,
    },
  };

export const mockWiseOwlUpdateChatStreamResponse: WiseOwlApiResponse<WiseOwlUpdateChatResponseData> =
  {
    success: true,
    message: "success",
    statusCode: 200,
    data: {
      accessToken: mockTwilioSyncAccessToken,
      syncDocumentSid: mockTwilioSyncDocumentSid,
    },
  };

export const mockOscHomeContent: WiseOwlGetHomeResponseData = {
  blocks: [
    {
      type: WiseOwlBlockType.PromptSuggestionGroup,
      display: WiseOwlBlockDisplayType.Persistent,
      values: {
        categories: [
          {
            name: "Getting Started with Twilio",
            suggestions: [
              "What are A2P 10DLC campaign approval requirements for all brand types?",
              "How can I port my US phone number to Twilio?",
              "How can I get the delivery status of an SMS Message?",
            ],
          },
          {
            name: "Help with My Account",
            suggestions: [
              "How do I reset/change my Twilio password?",
              "How much does a phone number cost?",
              "When will my invoice be available and where can I find it?",
            ],
          },
        ],
      },
    },
  ],
};

export const mockMessagingInsightsHomeContent: WiseOwlGetHomeResponseData = {
  blocks: [
    {
      type: WiseOwlBlockType.IntelligentDiscoveryHome,
      display: WiseOwlBlockDisplayType.Persistent,
      values: {
        lastNDays: 7,
        failedMessages: 11461,
        undeliveredMessages: 24615,
        totalMessages: 193682,
      },
    },
  ],
};

export const mockSalesforceHomeContent: WiseOwlGetHomeResponseData = {
  blocks: [
    {
      type: WiseOwlBlockType.PromptSuggestionGroup,
      display: WiseOwlBlockDisplayType.Persistent,
      values: {
        categories: [
          {
            name: "Suggested prompts",
            suggestions: [
              "What are some industries we’ve been successful in?",
              "What are three examples of e-commerce companies we’ve helped and how did we benefit them?",
            ],
          },
        ],
      },
    },
  ],
};

export const mockZendeskHomeContent: WiseOwlGetHomeResponseData = {
  blocks: [
    {
      type: WiseOwlBlockType.PromptSuggestionGroup,
      display: WiseOwlBlockDisplayType.Persistent,
      values: {
        categories: [
          {
            name: "Suggested prompts",
            suggestions: ["Summarize this ticket", "Suggest a reply"],
          },
        ],
      },
    },
  ],
};

export const mockGetChatSummaryByIdResponse: WiseOwlGetChatSummaryByIdResponseData =
  {
    description:
      "I need to know when my invoice will be available and where I can find it. Additionally, I require clarification on error code 30004, which indicates that message delivery failed because the destination is blocked from receiving the message. This error appears due to various reasons such as Do Not Disturb lists, mobile service plans, carrier blocking, device issues, national Do Not Call registries, and opt-out keywords. I need further assistance on both issues.",
    subject: "Questions Regarding Invoice and Error Code 30004",
    wasTranslated: false,
  };

export const mockTransferToLiveChatPreEngagementData: LiveChatPreEngagementData =
  {
    accountSid: "AC541262dd2c401687d00656d3811553ab",
    email: "hhartigan@twilio.com",
    friendlyName: "Hugh Hartigan",
    identity: "hhartigan@twilio.com",
    location: "https://help.stage.twilio.com",
    metadata:
      "%7B%22account%22%3A%7B%22sid%22%3A%22AC541262dd2c401687d00656d3811553ab%22%7D%2C%22user%22%3A%7B%22sid%22%3A%22US046e8c33ddaa77748de95b406cc454cc%22%2C%22email%22%3A%22hhartigan%40twilio.com%22%2C%22fullName%22%3A%22Hugh%20Hartigan%22%7D%2C%22customFields%22%3A%5B%7B%22id%22%3A28239607%2C%22value%22%3A%22AC541262dd2c401687d00656d3811553ab%22%7D%2C%7B%22id%22%3A28239617%2C%22value%22%3A%22US046e8c33ddaa77748de95b406cc454cc%22%7D%2C%7B%22id%22%3A28245318%2C%22value%22%3A%22p3_general_issue%22%7D%5D%2C%22tags%22%3A%5B%22sof_chat%22%5D%2C%22hcaCsatProps%22%3Anull%7D",
    productCategory: "support_accounts_billing",
    question:
      "I'd like to know when my invoice will be available and where I can find it. Additionally, I am encountering error code 30004 while trying to deliver messages. The assistant mentioned several possible causes, including the recipient's number being on a Do Not Disturb list, service plan limitations, carrier blocking, and device issues. I've attempted troubleshooting as suggested, including checking the Twilio Status Page and following SMS guidelines, but the issue persists. I need further assistance to resolve this.",
    url: "https://help.stage.twilio.com",
    userSid: "US046e8c33ddaa77748de95b406cc454cc",
  };

export const mockTransferToLiveChatBody: WiseOwlTransferToLiveChatBodyOsc = {
  chatFriendlyName: "Wise Owl",
  customerFriendlyName: "Cedric Robot",
  preEngagementData: JSON.stringify(mockTransferToLiveChatPreEngagementData),
};

export const mockTransferToLiveChatResponse: WiseOwlTransferToLiveChatResponseData =
  {
    blocks: [
      {
        type: WiseOwlBlockType.LiveChat,
        display: WiseOwlBlockDisplayType.Persistent,
        values: {
          liveChatId: "CH63c347794f3646848731708043366975",
          identity: "FXf6fed912c8de6a1890f2d5f86068edfe",
          token:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTS2E3MDY0ZGFmODdjZDA4NjhlMDc2OTE5NmJlMTNkMGQzLTE3MTk2MTY0OTYiLCJncmFudHMiOnsiaWRlbnRpdHkiOiJGWGY2ZmVkOTEyYzhkZTZhMTg5MGYyZDVmODYwNjhlZGZlIiwiY2hhdCI6eyJzZXJ2aWNlX3NpZCI6IklTZGU4NGU5NDY1MDQ2NDNhOTg3YjY5NDcxZDM4OTczYTYifSwiZGF0YV9zeW5jIjp7InNlcnZpY2Vfc2lkIjoiSVM5ZDZhZTVjMzU1ZWU5NDEzOWRkMTYwMWExZjM0MDRjYiJ9fSwiaWF0IjoxNzE5NjE2NDk2LCJleHAiOjE3MTk2MjAwOTYsImlzcyI6IlNLYTcwNjRkYWY4N2NkMDg2OGUwNzY5MTk2YmUxM2QwZDMiLCJzdWIiOiJBQ2ZlZjhiYzU0Mjc1MGU1NTg3OTYwOTJhOGY0NjAxNmE0In0.C0u1qgFqo8f2HP4R454Io9g4Omp2dXasnm8HvO3m1iI",
          ticketId: 2152214,
          chatActivitySyncMapId: "MPafc32b6bf5024c88833c8a3c097b110f",
        },
      },
    ],
  };
